import GlobalContext from "context/GlobalContext";
import Authmiddleware from "routes/Authmiddleware";

const App = () => {
  return (
    <GlobalContext>
      <Authmiddleware />
    </GlobalContext>
  );
};

export default App;
